// WS-PT-02 Path A: Transform fits-* filter labels to human-readable model names.
// Search & Discovery has no per-value label override UI; this strips the fits- prefix
// and substitutes the canonical model display name in the filter sidebar at render time.
// Tag slugs in Shopify remain canonical (fits-pro-vac-fs-6) for SEO and rule-targeting.

(function () {
  'use strict';

  var labelMap = {
    'fits-gofit-3': 'GoFit 3',
    'fits-gofit-6': 'GoFit 6',
    'fits-gofit-10': 'GoFit 10',
    'fits-super-coach-pro-6': 'Super Coach Pro 6',
    'fits-super-coach-pro-10': 'Super Coach Pro 10',
    'fits-provac-fs-6': 'ProVac FS 6',
    'fits-gofree-flex-pro-ii': 'GoFree Flex Pro II',
    'fits-gofit-3-cordless': 'GoFit 3 Cordless',
    'fits-gofit-6-cordless': 'GoFit 6 Cordless',
    'fits-proforce-1200xp': 'ProForce 1200XP',
    'fits-proforce-1500xp': 'ProForce 1500XP',
    'fits-progen-12': 'ProGen 12',
    'fits-progen-15': 'ProGen 15',
    'fits-proguard-4': 'ProGuard 4',
    'fits-proguard-10': 'ProGuard 10',
    'fits-proguard-15': 'ProGuard 15',
    'fits-proguard-20': 'ProGuard 20',
    'fits-sierra': 'Sierra (Legacy)',
    'fits-everest': 'Everest (Legacy)',
    'fits-super-coachvac': 'Super CoachVac (Legacy)',
    'fits-megavac': 'MegaVac (Legacy)',
    'fits-linevacer': 'LineVacer (Legacy)',
    'fits-aviationvac': 'AviationVac (Legacy)',
    'fits-quietpro-bp': 'QuietPro BP (Legacy)',
    'fits-tailvac': 'TailVac (Legacy)',
    'fits-super-halfvac': 'Super HalfVac (Legacy)'
  };

  function relabelFitsFilters(root) {
    var scope = root || document;
    // Dawn 15.4.1 facet markup: facet inputs carry the tag slug as `value` and a
    // sibling label element holds the visible text. Cover both the desktop sidebar
    // and the mobile facets-drawer rendering.
    var inputs = scope.querySelectorAll('input[name^="filter."][type="checkbox"][value^="fits-"]');
    inputs.forEach(function (input) {
      var slug = input.value;
      var displayName = labelMap[slug];
      if (!displayName) return;
      var labelEl = input.closest('label') || (input.id && scope.querySelector('label[for="' + input.id + '"]'));
      if (!labelEl) return;
      var textNode = Array.prototype.find.call(labelEl.childNodes, function (n) {
        return n.nodeType === Node.TEXT_NODE && n.textContent.trim().indexOf('fits-') === 0;
      });
      if (textNode) {
        textNode.textContent = textNode.textContent.replace(/fits-[a-z0-9-]+/, displayName);
      } else {
        // Fallback: span/div carrying the visible label
        var labelSpan = labelEl.querySelector('.facets__label, [data-label], span');
        if (labelSpan && labelSpan.textContent.trim().indexOf('fits-') === 0) {
          labelSpan.textContent = displayName;
        }
      }
    });
  }

  function init() {
    relabelFitsFilters(document);
    // Re-run after Dawn's AJAX facet refresh swaps the sidebar markup.
    var facetContainers = document.querySelectorAll('facet-filters-form, .facets-container, #FacetsWrapperDesktop, #FacetFiltersForm');
    if (!facetContainers.length || typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) relabelFitsFilters(document);
      });
    });
    facetContainers.forEach(function (c) {
      observer.observe(c, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
